<template>
    <v-col cols="12" class="text-center my-6">
    <h1 class="text-h5 align-center mb-6 secondary--text text--uppcase">
      <!-- <v-icon left color="accent" class="mb-1">mdi-shield-outline</v-icon> -->
      <!-- <span class="accent--text">Category: </span> -->
      <span v-html="title"></span>
    </h1>
    <p class="body-2 grey--text text--darken-1 mb-6 mx-auto" v-html="description" v-if="description" style="max-width: 720px;">
      Accumsan dignissim suscipit accumsan eleifend curae cum ultrices posuere a vestibulum a magnis metus ullamcorper donec augue a curabitur
    </p>
    <!-- <v-divider></v-divider> -->
  </v-col>
</template>

<script>
  export default {
    name: 'CategoryHeader',

    props: {
      title: {
        type: String,
        default: 'Tag'
      },
      description: {
        type: String,
        default: 'lorem ipsum dolor est amit'
      }
    }
  }
</script>